import React, { useState } from "react";
import Client from "../../../../../Objects/models/Client";
// import IndexStep from "../../../../../App/Courses/Declaration/IndexStep";
import { DataChildType, DataDisptachType } from "../../CourseDeclare";
import { useDispatch } from "react-redux";
// import {paragraphe} from "../../../../Teacher/Admin/Dashboard/Utils/Style";
import { displayError } from "../../../../../Utils/Function";
import { SET_COURSE_DECLARATION_INFO } from "../../../../../Redux/Reducers/DeclarationCourseReducers";
import validateSelects from "../../../../../Validation/MultiStep";
import { Subject } from "../../../../../Objects/models/Subject";
import { useQuery } from "@tanstack/react-query";
import AddressRepository from "../../../../../Repositories/AddressRepository";
import CourseFormatsSelect from "../../CourseFormatsSelect";
// import AddressSelect from "../../AddressSelect";
import { CourseType, courseTypes } from "../../staticData";
// import CreateAddressDialog from "../../CreateAddressDialog";
// import {AddLocation} from "@mui/icons-material";
import SelectMatiereFields from "../../../../../Components/Fields/SelectMatiereFields";
import { useEffect } from "react";
import IndexStep from "../../../../../App/DeclarationCourse/IndexStep";

type Props = {
  client?: Client;
  generalStep: any;
  handleChangeStep: (val: number) => void;
  dataChild: DataChildType;
  dataDispatch: DataDisptachType;
}

export default function ThirdStep({ client, generalStep, handleChangeStep }: Props) {
  const dispatch = useDispatch()
  const courseType = generalStep?.courseType as CourseType
  // const child = generalStep?.firstStep?.child
  const thirdStep = generalStep?.thirdStep
  const [error, setError] = useState({ format: false, price: false, matiere: false, terms: false })
  // const [openDialog, setOpenDialog] = useState(false)
  const [stepInfo, setStepInfo] = useState({
    selectedSubject: thirdStep ? thirdStep?.selectedSubject : null,
    selectedAddress: thirdStep ? thirdStep?.selectedAddress : null,
    selectedFormat: thirdStep ? thirdStep?.selectedFormat : null,
  })

  const { data: userAddresses } = useQuery({
    queryKey: [client?.id, 'user-addresses'],
    queryFn: () => AddressRepository.getClientAddresses(client?.id!),
  })

  const courseFormats = [
    {
      id: 1,
      text: "À distance (non éligible au crédit d'impôt)",
      code: "distance"
    },
    {
      id: 2,
      text: "À domicile",
      code: "domicile"
    }
  ]

  const handleNextStep = (value: number) => {
    let hasError = false;
    // Check if course format was chosen
    if (!stepInfo.selectedFormat) {
      setError((prev) => ({ ...prev, format: true }));
      hasError = true;
    } else {
      setError((prev) => ({ ...prev, format: false }));
    }

    // Check if subject was chosen
    if (!stepInfo.selectedSubject) {
      setError((prev) => ({ ...prev, matiere: true }));
      hasError = true;
    } else {
      setError((prev) => ({ ...prev, matiere: false }));
    }

    if (hasError) return;
    dispatch({
      type: SET_COURSE_DECLARATION_INFO,
      payload: {
        step: value,
        ...generalStep,
        thirdStep: stepInfo,
      },
    });
    handleChangeStep(value);
  }

  useEffect(() => {
    if (
      userAddresses &&
      userAddresses.length > 0 &&
      !stepInfo.selectedAddress
    ) {
      setStepInfo((curr) => ({
        ...curr,
        selectedAddress: {
          id: userAddresses[0].id,
          formattedAddress: userAddresses[0].formattedAddress,
        },
      }));
    }
  }, [userAddresses, stepInfo.selectedAddress, setStepInfo]);



  const displayBody = () => {
    return (
      <div className="h-full space-y-6">

        {stepInfo.selectedFormat?.code === "distance" && (
          <div className="bg-yellow-100 text-yellow-800 p-3 rounded-md">
            ⚠️ Les cours à distance ne sont pas éligibles à l’avance immédiate
            du crédit d’impôt.
          </div>
        )}

        <div>
          {/*TODO: mettre des radios boutons à la place*/}
          <CourseFormatsSelect
            selectedFormat={stepInfo.selectedFormat}
            setSelectedFormat={(format) =>
              setStepInfo((curr) => ({ ...curr, selectedFormat: format }))
            }
            options={courseFormats}
          />
          {displayError(
            error.format,
            "Veuillez sélectionner un format de cours."
          )}
        </div>
        <div>
          <div className="w-full space-y-2">
            <SelectMatiereFields
              callBack={(val: Subject) =>
                setStepInfo((curr) => ({ ...curr, selectedSubject: val }))
              }
              validation={validateSelects}
              value={stepInfo.selectedSubject}
              placeholder="Ex : Mathématiques"
              label="Sélectionnez la matière souhaitée"
              matieres={stepInfo.selectedSubject}
              sizes="16"
            />
            {displayError(
              error.matiere,
              validateSelects(stepInfo.selectedSubject).message
            )}
          </div>
        </div>
        {/* <div>
          {isLoadingAddresses ? (
            <p>Chargement de vos adresses...</p>
          ) : errorAddresses ? (
            <div className="flex items-center gap-4">
              <p>Une erreur est survenue lors du chargement de vos adresses</p>
              <button onClick={() => refetchAddresses()}>Ressayer</button>
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <AddressSelect
                selectedAddress={stepInfo.selectedAddress}
                setSelectedAddress={(address) =>
                  setStepInfo((curr) => ({
                    ...curr,
                    selectedAddress: {
                      id: address.id,
                      formattedAddress: address.formattedAddress,
                    },
                  }))
                }
                options={userAddresses || []}
              />
              <button
										onClick={() => setOpenDialog(true)}
										type="button"
										className={`shadow-md flex items-center px-4 lg:py-3 py-2  justify-center flex-shrink-0 font-bold border text-first bg-white rounded-full hover:bg-gray-100 `}
									>
										<AddLocation className="w-5 h-5" />
									</button>
              <CreateAddressDialog
                open={openDialog}
                handleCloseIcon={() => setOpenDialog(false)}
                client={client!}
              />
            </div>
          )}
        </div> */}
        {/* <pre>
					{JSON.stringify(stepInfo, null, 2)}
				</pre> */}
      </div>
    );
  }

  return (
    <IndexStep
      title={`${courseTypes[courseType]} 📚`}
      body={displayBody()}
      handleChangeStep={handleChangeStep}
      handleNexStep={handleNextStep}
      value={4}
      step={3}
      generalStep={generalStep}
    />
  )
}